module.exports = __webpack_public_path__ + "img/kia-cerato.bb6ead3d.jpeg";